<app-modal #modalComponent>
    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left p-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900">{{title}}</h3>
        <div class="mt-2 text-sm text-gray-500">{{message}}</div>
    </div>

    <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
        <button (click)="submit()"
            class="px-2 py-1 text-xs text-white rounded-md focus:outline-none {{buttonClass}}">
            {{buttonText}}
        </button>
        <button (click)="close()" type="button"
            class="px-2 py-1 text-xs text-green-700 bg-white rounded-md focus:outline-none">
            Close
        </button>
    </div>
</app-modal>
